import { FC } from 'react'

export const CheckIcon: FC<{ isActive?: boolean; color?: string }> = ({ isActive, color }) => {
  return (
    <svg width="18" height="14" viewBox="0 0 18 14" xmlns="http://www.w3.org/2000/svg">
      <path
        fill={color ? color : isActive ? '#fff' : '#8D8D8D'}
        d="M6 11.17L1.83 7.00003L0.409996 8.41003L6 14L18 2.00003L16.59 0.590027L6 11.17Z"
      />
    </svg>
  )
}
